/* Kishori — image save protection
   Blocks: right-click context menu on images, drag-to-save, iOS long-press
   Not blocked: screenshots, dev tools, view-source (nothing can) */
(function () {
  function isImgLike(el) {
    if (!el) return false;
    if (el.tagName === 'IMG' || el.tagName === 'PICTURE') return true;
    if (el.closest && el.closest('img, picture, .kb-hero__slide, .kb-card__media, .kb-pdp__main-img, .kb-coll-tile__media, .kb-lcoll__media, .kb-story__media, .kb-abhi, .kb-phero, .kb-blog__media, .kb-art__hero, .kb-insta__tile, .kb-cart__img')) {
      return true;
    }
    return false;
  }

  document.addEventListener('contextmenu', function (e) {
    if (isImgLike(e.target)) e.preventDefault();
  }, false);

  document.addEventListener('dragstart', function (e) {
    if (e.target && (e.target.tagName === 'IMG' || isImgLike(e.target))) e.preventDefault();
  }, false);

  document.addEventListener('selectstart', function (e) {
    if (e.target && e.target.tagName === 'IMG') e.preventDefault();
  }, false);

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('img').forEach(function (img) {
      img.setAttribute('draggable', 'false');
      img.setAttribute('oncontextmenu', 'return false;');
    });
  });
})();
